import { createContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

export const ContextoAutenticacao = createContext(null);

export function ContextoAutenticacaoProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    const tokenCookie = Cookies.get("token");

    if (!tokenCookie) {
      setUsuario(null);
      setCarregando(false);
      return;
    }

    try {
      const { jwt } = JSON.parse(tokenCookie);
      const claims = jwtDecode(jwt);
      setUsuario({
        nome: claims.nome,
        grupoDeUsuarioId: Number(claims.GrupoDeUsuarioId),
        funcionalidades: claims.funcionalidades || [],
        primeiroLogin: claims.primeiroLogin,
      });
    } catch (error) {
      Cookies.remove("token");
      setUsuario(null);
    } finally {
      setCarregando(false);
    }
  }, []);

  return (
    <ContextoAutenticacao.Provider value={{ usuario, carregando }}>
      {children}
    </ContextoAutenticacao.Provider>
  );
}
